import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CancelIcon from "@mui/icons-material/Cancel";
import CircleIcon from "@mui/icons-material/Circle";

export const getStatusColor = (status, theme) => {
    switch (status?.toLowerCase()) {
        case "completed":
        case "executed":
            return theme.palette.success.main;

        case "pending":
        case "processing":
            return theme.palette.warning.main;

        case "failed":
        case "cancelled":
            return theme.palette.error.main;

        case "registered":
            return theme.palette.success.main;

        case "not registered":
            return theme.palette.grey[500];

        default:
            return theme.palette.grey[500];
    }
};

export const getStatusText = (status) => {
    switch (status?.toLowerCase()) {
        case "completed":
        case "executed":
            return "Completed";

        case "pending":
        case "processing":
            return "Pending";

        case "failed":
            return "Failed";

        case "cancelled":
            return "Cancelled";

        case "registered":
            return "Registered";

        case "not registered":
            return "Not Registered";

        default:
            return "Unknown";
    }
};

export const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
        case "completed":
        case "executed":
            return CheckCircleIcon;

        case "pending":
        case "processing":
            return AccessTimeIcon;

        case "failed":
        case "cancelled":
            return CancelIcon;

        case "registered":
            return CheckCircleIcon;

        case "not registered":
            return CircleIcon;

        default:
            return null;
    }
};

export const getOrderStatus = (status, theme) => {
    return {
        color: getStatusColor(status, theme),
        text: getStatusText(status),
        Icon: getStatusIcon(status)
    };
};